import { useEffect } from "react";

// Lightweight per-route SEO (no dependency). Sets title, meta description,
// canonical + Open Graph tags for the current public page. Safe for the SPA;
// does not affect any app functionality.
const setMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [k, v] = selector.replace("meta[", "").replace("]", "").split("=");
    el.setAttribute(k, v.replace(/["']/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export function useSeo({ title, description, canonicalPath, ogTitle, ogDescription, ogType = "website" }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta('meta[name="description"]', "content", description);

    const url = canonicalPath ? `https://simplyrefer.com.au${canonicalPath}` : undefined;
    if (url) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    }

    setMeta('meta[property="og:title"]', "content", ogTitle || title);
    setMeta('meta[property="og:description"]', "content", ogDescription || description);
    setMeta('meta[property="og:type"]', "content", ogType);
    if (url) setMeta('meta[property="og:url"]', "content", url);
  }, [title, description, canonicalPath, ogTitle, ogDescription, ogType]);
}
